<script>
import autocomplete from "../../packages/datakode/nuxt-datakode-utils/components/form/autocomplete.vue"
import { get, useOnlineStore } from "../../store"

export default {
    name: "OfflineAutoCompleteField",
    extends: autocomplete,
    props: ["epciCommune", "series", "archiveRoom"],
    watch: {
        async series() {
            await this.getItems()
            await this.getBasicData()
        },
        async epciCommune() {
            await this.getItems()
            await this.getBasicData()
        },
        async archiveRoom() {
            await this.getItems()
            await this.getBasicData()
        },
    },
    methods: {
        async getBasicData() {
            if (this.value && this.rule) {
                let search = ""
                if (this.isMultiple && Array.isArray(this.value)) {
                    search = this.value.map(val => val.k).join(",")
                }
                else {
                    search = this.fetchKey ? this.fetchKey : this.value.k
                }
                const url = this.requestPath.split("?")[0]
                if (useOnlineStore().online) {
                    if (search) {
                        const query = { k: search }
                        if (this.epciCommune && this.epciCommune.id) {
                            query["filter[where_in_epciCommune]"] = this.epciCommune.id
                        }
                        if (this.series && this.series.id) {
                            query["filter[series_id]"] = this.series.id
                        }
                        if (this.archiveRoom && this.archiveRoom.id) {
                            query["filter[where_in_archive_room]"] = this.archiveRoom.id
                        }
                        try {
                            const res = await this.$api.setRequest({
                                url: `${this.requestPath}`,
                                // query :  [{name : "k", value : k }],
                                query,

                                method: "GET",
                            })
                            this.setValue = res.data.length ? this.isMultiple ? res.data : res.data[0] : null
                            this.autocompleteData = [...this.autocompleteData, ...res.data]
                        }
                        catch (e) {
                            console.error(e)
                        }
                    }
                }
                else if (search && window && window.indexedDB) {
                    let data = []
                    const queryString = this.requestPath.split("?")[1] || ""
                    const urlParams = new URLSearchParams(queryString)

                    if (await get(`${url}-list`)) {
                        // eslint-disable-next-line eqeqeq
                        data = (await get(`${url}-list`)).filter(d => !search || d.v == search || d.name == search || d.k == search)
                    }

                    const limitToId = urlParams.get("filter[limit_to_accessible_for]")
                    if (limitToId) {
                        const parentId = Number.parseInt(limitToId)
                        const allCommunes = await get(`${url}-list`) || []
                        const parentCommune = allCommunes.find(d => d.id === parentId)

                        if (parentCommune) {
                            const allowedIds = [parentId]
                            if (parentCommune.accessible_communes) {
                                parentCommune.accessible_communes.forEach(ac => allowedIds.push(ac.id))
                            }
                            data = data.filter(d => allowedIds.includes(d.id))
                        }
                        else {
                            data = data.filter(d => d.id === parentId)
                        }
                    }

                    if (this.epciCommune && this.epciCommune.id) {
                        data = data.filter(d => d.epciCommune && d.epciCommune.id === this.epciCommune.id)
                    }

                    if (this.series && this.series.id) {
                        data = data.filter(d => d.series && d.series.id === this.series.id)
                    }

                    if (this.archiveRoom && this.archiveRoom.id) {
                        data = data.filter(d => d.archive_room && d.archive_room.id === this.archiveRoom.id)
                    }

                    this.setValue = data.length ? this.isMultiple ? data : data[0] : null
                    this.autocompleteData = [...data]
                }
            }
        },
        async getItems(event) {
            if (event) { // reset infinite scroll on search change
                this.page = 1
                this.last_page = null
                this.autocompleteUrlChoices = []
                this.search = event.srcElement.value
            }
            if (useOnlineStore().online) {
                if (this.requestPath) {
                    this.loading = true
                    let f = ""
                    if (this.epciCommune && this.epciCommune.id) {
                        f = `&filter[where_in_epciCommune]=${this.epciCommune.id}`
                    }

                    if (this.series && this.series.id) {
                        f = `&filter[series_id]=${this.series.id}`
                    }
                    if (this.archiveRoom && this.archiveRoom.id) {
                        f = `&filter[where_in_archive_room]=${this.archiveRoom.id}`
                    }

                    const pagination = `&page[number]=${this.page}`
                    try {
                        const res = await this.$api.setRequest({
                            url: `${this.requestPath}${this.search ? `&search=${this.search}` : ""}${f}${pagination}`,
                            method: "GET",
                        })
                        if (this.page === 1) {
                            this.autocompleteUrlChoices = []
                        }
                        this.last_page = res.meta.last_page
                        if (res.data.length) {
                            this.autocompleteUrlChoices = [...this.autocompleteUrlChoices, ...res.data]
                        }
                        else {
                            this.autocompleteUrlChoices = this.autocompleteData.filter(data => data ? data.k === this.value : false)
                        }
                    }
                    catch (e) {
                        console.error(e)
                    }
                    this.loading = false
                }
            }
            else if (this.requestPath && window && window.indexedDB) {
                const url = this.requestPath.split("?")[0]
                const queryString = this.requestPath.split("?")[1] || ""
                const urlParams = new URLSearchParams(queryString)

                this.autocompleteUrlChoices = []
                let data = []

                if (await get(`${url}-list`)) {
                    // eslint-disable-next-line eqeqeq
                    data = (await get(`${url}-list`)).filter(d => !this.search || d.v == this.search || d.name == this.search || d.k == this.search)
                }

                const limitToId = urlParams.get("filter[limit_to_accessible_for]")
                if (limitToId) {
                    const parentId = Number.parseInt(limitToId)
                    const parentCommune = data.find(d => d.id === parentId)

                    if (parentCommune) {
                        const allowedIds = [parentId]
                        if (parentCommune.accessible_communes) {
                            parentCommune.accessible_communes.forEach(ac => allowedIds.push(ac.id))
                        }
                        data = data.filter(d => allowedIds.includes(d.id))
                    }
                    else {
                        data = data.filter(d => d.id === parentId)
                    }
                }

                if (this.epciCommune?.id) {
                    data = data.filter(d => d.epciCommune?.id === this.epciCommune.id)
                }
                if (this.series && this.series.id) {
                    data = data.filter(d => d.series && d.series.id === this.series.id)
                }
                if (this.archiveRoom && this.archiveRoom.id) {
                    data = data.filter(d => d.archive_room && d.archive_room.id === this.archiveRoom.id)
                }
                this.autocompleteUrlChoices = [...data]
            }
        },
    },
}
</script>

<template>
    <FormLabel v-if="data && (value !== undefined || rule)">
        <v-autocomplete
            v-if="rule"
            :id="customId || dataKey"
            v-model="setValue"
            :multiple="isMultiple"
            :items="autocompleteUrlChoices || []"
            :clearable="isClearable"
            item-title="v"
            item-value="v"
            variant="outlined"
            density="compact"
            autocomplete="off"
            :hide-no-data="true"
            :loading="loading"
            :disabled="disabled"
            :chips="isMultiple && Array.isArray(setValue)"
            :closable-chips="isMultiple && Array.isArray(setValue)"
            no-data-text="Aucun choix disponible"
            :error-messages="getErrors()"

            @update:model-value="updateDataBeforeEmit($event); validation?.$touch()"
            @input="event => { getItemsDebounce(event); validation?.$touch() }"
            @click:clear="event => getItems(event)"
            @blur="validation && validation.$touch()"
        >
            <template #selection="{ item }">
                <v-chip
                    v-if="isChips && !loading"
                    :variant="$config.public.chips_variant || 'tonal'"
                    size="small"
                >
                    {{ item.value }}
                </v-chip>
                <span v-else-if="!loading">{{ item.value }}</span>
                <span v-else>Chargement en cours...</span>
            </template>
            <template #append-item>
                <div v-intersect="endIntersect" />
            </template>
        </v-autocomplete>

        <div v-else-if="showValue">
            <div v-if="withTooltip">
                <v-tooltip :text="$translate(`${translationName}.${dataKey}.tooltip.${value}`)">
                    <template #activator="{ props }">
                        <v-chip
                            v-if="isChips"
                            :variant="$config.public.chips_variant || 'tonal'"
                            v-bind="props"
                            :color="$getColor(showValue)"
                        >
                            {{ showValue }}
                        </v-chip>
                        <span
                            v-else
                            v-bind="props"
                        > {{ showValue }}</span>
                    </template>
                </v-tooltip>
            </div>
            <div v-else>
                <template v-if="Array.isArray(showValue)">
                    <span
                        v-for="(val, i) in showValue"
                        :key="val"
                    >
                        <v-chip
                            v-if="isChips"
                            :variant="$config.public.chips_variant || 'tonal'"
                            :color="$getColor(`${translationName}.${dataKey}.${value}`)"
                        >
                            {{ val }}
                        </v-chip>
                        <span v-else>{{ val }}{{ i !== showValue.length - 1 ? ', ' : '' }} </span>
                    </span>
                </template>
                <template v-else>
                    <v-chip
                        v-if="isChips"
                        :variant="$config.public.chips_variant || 'tonal'"
                        :color="$getColor(`${translationName}.${dataKey}.${value}`)"
                    >
                        {{ showValue }}
                    </v-chip>
                    <span v-else>{{ showValue }}</span>
                </template>
            </div>
        </div>
        <div v-else>
            <small class="font-italic text-disabled">-</small>
        </div>
    </FormLabel>
</template>
